import { FelaCSS, colors, spacing } from '@bridebook/ui';
import { WebsiteTileVariant } from '@bridebook/web/components/wedding-website/view-mode/partials/tile-component/wedding-website-tile-component';
import { PALETTE_EXTRA_ASSETS } from '@bridebook/web/lib/wedding-website/constants/themes';
import { Palettes } from '@bridebook/web/lib/wedding-website/types';
import { buildImageSrc } from '@bridebook/toolbox/src/buildImageUrl';

interface IStyles {
  wrapper: FelaCSS;
  container: FelaCSS;
  containerRoses: FelaCSS;
  containerFoliage: (variant: WebsiteTileVariant) => FelaCSS;
  containerWhimsical: (variant: WebsiteTileVariant) => FelaCSS;
  containerWithImage: (url: string) => FelaCSS;
  title: FelaCSS;
  titleTextWrapper: FelaCSS;
  textWrapper: FelaCSS;
  textPlaceholder: FelaCSS;
  button: FelaCSS;

  paletteRosesAsset: (corner: 'top-left' | 'bottom-right') => FelaCSS;
  paletteFoliageAsset: (position: 'left' | 'right') => FelaCSS;
  paletteWhimsicalAsset: (position: 'left' | 'right') => FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    containerMinWidthDesktop: {
      borderRadius: '16px',
    },
  },
  container: {
    paddingHorizontal: spacing[6],
    paddingVertical: spacing[12],
    gap: spacing[10],
    textAlign: 'center',
    width: '100%',
  },
  containerRoses: {
    paddingHorizontal: spacing[6],
    paddingVertical: spacing[12],
    gap: spacing[10],
    textAlign: 'center',
    width: '100%',
    backgroundColor: 'rgba(251, 251, 246, 1)',
  },
  containerFoliage: (variant: WebsiteTileVariant) => ({
    paddingHorizontal: spacing[6],
    paddingTop: spacing[20],
    paddingBottom: spacing[12],
    gap: spacing[10],
    textAlign: 'center',
    width: '100%',
    backgroundColor:
      variant === WebsiteTileVariant.Primary
        ? colors.white
        : variant === WebsiteTileVariant.Secondary
          ? 'rgba(237, 239, 240, 1)'
          : 'rgba(239, 248, 242, 1)',
  }),
  containerWhimsical: (variant: WebsiteTileVariant) => ({
    paddingHorizontal: spacing[6],
    paddingTop: spacing[20],
    paddingBottom: spacing[12],
    gap: spacing[10],
    textAlign: 'center',
    width: '100%',
    backgroundColor:
      variant === WebsiteTileVariant.Primary ? 'rgba(220, 146, 169, 1)' : 'rgba(238, 201, 213, 1)',
  }),
  containerWithImage: (url: string) => ({
    paddingHorizontal: spacing[6],
    paddingVertical: spacing[12],
    gap: spacing[10],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${buildImageSrc(url, { h: 875 })})`,
    textAlign: 'center',
    width: '100%',
  }),
  title: {
    alignSelf: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'row',
    width: '100%',
  },
  titleTextWrapper: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    flexGrow: 1,
  },
  textWrapper: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    justifyContent: 'center',
  },
  textPlaceholder: {
    opacity: 0.6,
  },
  button: {
    width: 'fit-content',
    alignSelf: 'center',
  },

  paletteRosesAsset: (corner: 'top-left' | 'bottom-right') => ({
    position: 'absolute',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${buildImageSrc(PALETTE_EXTRA_ASSETS[Palettes.Roses], { h: 300 })})`,
    width: 76,
    height: 114,
    ...(corner === 'top-left'
      ? {
          top: spacing[4],
          left: spacing[5],
        }
      : {
          bottom: spacing[4],
          right: spacing[5],
          transform: 'rotate(180deg)',
        }),
  }),
  paletteFoliageAsset: (position: 'left' | 'right') => ({
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${buildImageSrc(PALETTE_EXTRA_ASSETS[Palettes.Foliage], {
      h: 300,
    })})`,
    transform: `scaleX(${position === 'left' ? '1' : '-1'})`,
    width: 80,
    minWidth: 80,
    height: 120,
  }),
  paletteWhimsicalAsset: (position: 'left' | 'right') => ({
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${buildImageSrc(PALETTE_EXTRA_ASSETS[Palettes.Whimsical], {
      h: 300,
    })})`,
    transform: `scaleX(${position === 'left' ? '1' : '-1'})`,
    width: 65,
    minWidth: 65,
    height: 120,
  }),
};

export default styles;
